import React, { useEffect, useState } from "react";
// components
import { Header } from "../../../../components/Landing/Header/haeder.view";
import { Footer } from "../../../../components/Landing/Footer";
// import { BannerJurados } from "../../components/BannerJurados";

// styled components
import { Button, Form, Input, Typography } from "antd";
import { useRegitrarUsuarioUME } from "../../../../hooks/useRegitrarUsuarioUME";


import { BannerGlobal } from "../../components/Banner";
import { BreadCrumb } from "../../../../components/Landing/Breadcrumb/breadcrumb.view";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../hooks/useUser";
import ModalSuccess from './../../../../utils/Alerts/ModalSuccess';
import ModalWarning from "../../../../utils/Alerts/ModalWarning";
import { ObjNotificaciones } from "../../../../config/notificaciones";

export const CambiarContrasena = () => {
  const navigate = useNavigate();
  const { Text, Paragraph, Title } = Typography;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isModal, setShowModal] = useState<boolean>(false);
  const [showConPassword, setShowConPassword] = useState<boolean>(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState<boolean>(false);
  const [requiredMark, setRequiredMarkType] = useState<any>("optional");
  const [formErrors, setFormErrors] = useState<any>();
  const [_user, set_user] = useState<any>({});
  const [redirect, setRedirect] = useState(false);
  const [modalFallo, setModalFallo] = useState(false);
  const [_data, _setData] = useState<any>({});

  const [formData, setFormData] = useState<any>({
    numero_identicacion: "",
    passwordCurrent: "",
    newPassword: "",
    confirmPassword: "",
  });

  const { cambiarContraseniaUsuario } = useRegitrarUsuarioUME();
  const { getUser } = useUser()

  const onRequiredTypeChange = ({ requiredMarkValue }: any) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const onAceptar = () => {
    if (redirect) {
      navigate("/login")
      return setShowModal(false);
    }
    return setModalFallo(false)
  }



  function formValidation() {
    let formErrors: any = {};
    let formIsValid = true;
    if (!formData.numero_identicacion) {
      formIsValid = false;
      formErrors["numero_identicacion"] = true;
    }
    if (!formData.newPassword) {
      formIsValid = false;
      formErrors["newPassword"] = true;
    }
    if (!formData.confirmPassword) {
      formIsValid = false;
      formErrors["confirmPassword"] = true;
    }

    if (!(formData.confirmPassword === formData.newPassword)) {
      console.log("formData.newPassword:===", formData.newPassword);
      console.log("formData.confirmPassword: ===", formData.confirmPassword);
      console.log(
        "formData.confirmPassword === formData.newPassword:=== ",
        !(formData.confirmPassword === formData.newPassword)
      );
      formIsValid = false;
      formErrors["confirmPasswords"] = true;
      formErrors["newPasswords"] = true;
    }
    setFormErrors(formErrors);
    return formIsValid;
  }

  useEffect(() => {
    if (localStorage.token) {
      console.log('entro');
      _getUser();
    }

  }, [localStorage.token])

  const _getUser = async () => {
    const usuario = await getUser();
    set_user(usuario);
  }


  const onSubmit = async () => {
    if (formValidation()) {
      const { numero_identicacion, passwordCurrent, newPassword, confirmPassword } = formData;

      if ((newPassword.length >= 8 && confirmPassword.length >= 8) && (newPassword.length <= 20 && confirmPassword.length <= 20)) {
        var { data } = await cambiarContraseniaUsuario(numero_identicacion, passwordCurrent, newPassword);
      } else {
        return ObjNotificaciones.MSG_ERROR('warning', '¡No cumple con los criterios señalados!', 'La contraseña debe contener mínimo 8 caracteres hasta un máximo de 20');
      }
      
      if (data && data.message && data.message === "La contraseña se cambió correctamente." || data.message === "Success") {
        setRedirect(true);
        setShowModal(true);
      } else {
        setModalFallo(true);
        // return openNotification({
        //   titulo: "Error",
        //   descripcion: data.message,
        //   placement: "bottomRight",
        // });
      }
      _setData(data);
    }
  };
  const routes = [
    { icon: <></>, nombre: "Alcaldía de Medellín" },
    { icon: <></>, nombre: "Secretaría de Cultura Ciudadana" },
    { icon: <></>, nombre: "Cambiar contraseña" },
  ];

  return (
    <div>
      <Header />
      <BreadCrumb routes={routes} />
      <BannerGlobal
        Description="Convocatoria de fomento y estímulos para el arte y la cultura"
        Title="Cambiar contraseña"
      />
      <div className="container-fluid2 ">
        <div className="row ">
          <div
            className="col-12 font-family-Montserrat-Regular font-size-18px"
            style={{ marginTop: "2%", marginBottom: "3%" }}

          >
            Hola <Text style={{ color: "#ae3e97" }}>
              {`${_user?.nombres || ""} ${_user?.apellidos || ""}`}
            </Text>, por tu seguridad debes cambiar la contraseña.
          </div>
          <div className="col-12 font-family-Montserrat-Regular font-size-18px mb-3" >
            Cambia tu contraseña
            <hr />
          </div>

          <div className="col-12 font-size-14px font-family-Montserrat-Bold mb-4">
            La contraseña debe tener entre 8 y 20 caracteres. Contener números y letras que se pueden combinar en mayúsculas y minúsculas. Y un carácter especial
            {/* la contraseña debe tener mínimo 15 caracteres y máximo 20, Debe tener al menos 1 número. */}
          </div>



          <div className="col-12">
            <Form
              layout="vertical"
              initialValues={{
                requiredMarkValue: requiredMark,
              }}
              onValuesChange={onRequiredTypeChange}
              autoComplete="off"
              requiredMark={requiredMark}
            >
              <div className="row">
                <div className="col-12 col-md-3">
                  <Form.Item
                    label={<p className="">Número de identificación</p>}
                    required
                    validateStatus={!formData.numero_identicacion && formErrors?.numero_identicacion && "error"}
                    help={
                      !formData.numero_identicacion &&
                      formErrors?.numero_identicacion &&
                      "Campo obligatorio"
                    }
                  >
                    <Input
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          numero_identicacion: e.target.value,
                        })
                      }
                      value={formData?.numero_identicacion}
                      prefix="No."
                      placeholder=""
                      type="number"
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-3">
                  <Form.Item
                    label={<p className="">Contraseña provisional</p>}
                    required
                    validateStatus={!formData.passwordCurrent && formErrors?.passwordCurrent && "error"}
                    help={!formData.passwordCurrent && formErrors?.passwordCurrent && "Contraseña actual is requerida"}
                  >
                    <Input
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          passwordCurrent: e.target.value,
                        })
                      }
                      value={formData?.passwordCurrent}
                      placeholder=""
                      type={`${showCurrentPassword ? "text" : "password"}`}
                      suffix={
                        <div
                          className={`active-showpassbtn curser-pointer `}
                          onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                          style={{ fontSize: '12px' }}
                        >
                          VER
                        </div>
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-3">
                  <Form.Item
                    validateStatus={
                      formErrors?.newPasswords ? "error" : !formData.newPassword && formErrors?.newPassword && "error"
                    }
                    help={
                      formErrors?.newPasswords
                        ? "Nueva contraseña y confirmación no son iguales"
                        : !formData.newPassword && formErrors?.newPassword && "Campo obligatorio"
                    }
                    label="Nueva contraseña"
                    required
                  >
                    <Input
                      placeholder=""
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          newPassword: e.target.value,
                        })
                      }
                      value={formData?.newPassword}
                      type={`${showPassword ? "text" : "password"}`}
                      suffix={
                        <div
                          className={`active-showpassbtn curser-pointer `}
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ fontSize: '12px' }}
                        >
                          VER
                        </div>
                      }
                    />
                  </Form.Item>
                </div>
                <div className="col-12 col-md-3">
                  <Form.Item
                    label="Confirmar contraseña"
                    required
                    validateStatus={
                      formErrors?.confirmPasswords
                        ? "error"
                        : !formData.confirmPassword && formErrors?.confirmPassword && "error"
                    }
                    help={
                      formErrors?.confirmPasswords
                        ? "Nueva contraseña y Confirmación no son iguales"
                        : !formData.confirmPassword && formErrors?.confirmPassword && "Campo obligatorio"
                    }
                  >
                    <Input
                      placeholder=""
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          confirmPassword: e.target.value,
                        })
                      }
                      value={formData?.confirmPassword}
                      type={`${showConPassword ? "text" : "password"}`}
                      suffix={
                        <div
                          className="curser-pointer active-showpassbtn "
                          onClick={() => setShowConPassword(!showConPassword)}
                          style={{ fontSize: '12px' }}
                        >
                          VER
                        </div>
                      }
                    />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
          <div className="btn_con_re">
            <div className="justify-content-end d-flex">
              <Button onClick={() => onSubmit()} htmlType="submit" className="button-azul-radius font-size-11px">
                Cambiar contraseña
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ModalSuccess
        visualizar={isModal}
        setVisualizar={setShowModal}
        onAceptar={onAceptar}
        titlle="Cambio de contraseña exitoso"
        description="se ha cambiado correctamente la contraseña"
        subdescription="Acepta para continuar"
      />
      <ModalWarning
        visualizar={modalFallo}
        setVisualizar={setModalFallo}
        onAceptar={onAceptar}
        description={_data.message}
        subdescription="Intentalo de nuevo"
      />
    </div>
  );
};
